import { Drawer, Group, Text } from '@mantine/core';
import { ReactComponent as IconKebab } from './img/iconKebabBlue.svg';
import { ReactComponent as IconClose } from './img/iconCloseGray.svg';
import styles from './ContractActions.module.scss';
import { useContractActions } from './hooks/useContractActions';
import { ModalConfirm } from './ModalConfirm';
import { ModalComment } from './ModalComment';
import { ContractActionsContent } from './ContractActions';
import { useState } from 'react';
import { ContractStatus, ContractType } from 'redux/Api/contractsApi/type';

export interface ContractActionsDrawerProps {
  contract: ContractType;
  status: ContractStatus;
  isResident: boolean;
}

export const ContractActionsDrawer: React.FC<ContractActionsDrawerProps> = ({
  contract,
  status,
  isResident,
}) => {
  const [opened, setOpened] = useState(false);
  const {
    isMvdNotified,
    isMvdNotifiedOnTermination,
    handleItemClick,
    handleMvdNotificationToggle,
    showRevokeModal,
    setShowRevokeModal,
    confirmRevokeContract,
    showTerminateModal,
    setShowTerminateModal,
    confirmTerminateContract,
    showCommentModal,
    setShowCommentModal,
    confirmAddComment,
    showTerminateModalWithOrders,
    setShowTerminateModalWithOrders,
    isDownloadingContract,
  } = useContractActions(contract);

  return (
    <>
      <IconKebab className={styles.kebabIcon} onClick={() => setOpened(true)} />
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        position='bottom'
        padding='md'
        withCloseButton={false}
        zIndex={100001}
        styles={{
          content: {
            height: 'fit-content',
            borderRadius: '13px 13px 0px 0px',
            backgroundColor: '#FFF',
            paddingBottom: '20px',
            boxShadow: '0px 0px 10px 0px rgba(0, 32, 51, 0.10)',
          },
          body: {
            padding: '0',
          },
        }}>
        <Group justify='space-between'>
          <div style={{ width: '20px' }}></div>
          <Text fz={20} fw={500} lh={'24px'} c={'#121922'}>
            № {contract.number}
          </Text>
          <IconClose
            onClick={() => setOpened(false)}
            style={{
              width: '48px',
              height: '48px',
              padding: '12px',
              cursor: 'pointer',
            }}
          />
        </Group>
        <ContractActionsContent
          status={status}
          isResident={isResident}
          onItemClick={async (label) => {
            await handleItemClick(label);
            setOpened(false);
          }}
          isMvdNotified={isMvdNotified}
          isMvdNotifiedOnTermination={isMvdNotifiedOnTermination}
          onMvdNotificationToggle={handleMvdNotificationToggle}
          contractId={contract.id}
          isDownloadingContract={isDownloadingContract}
        />
      </Drawer>

      {showRevokeModal && (
        <ModalConfirm
          setShowLogoutModal={setShowRevokeModal}
          title='Отозвать договор?'
          text={
            isResident
              ? 'Будет создаваться отдельный договор на каждый заказ'
              : 'Ты не сможешь больше отправлять заказы исполнителю'
          }
          confirmText='Отозвать'
          onConfirm={confirmRevokeContract}
        />
      )}

      {showTerminateModal && (
        <ModalConfirm
          setShowLogoutModal={setShowTerminateModal}
          title='Расторгнуть договор?'
          text={
            isResident
              ? 'Будет создаваться отдельный договор на каждый заказ'
              : 'Ты не сможешь больше отправлять заказы исполнителю. Не забудь уведомить МВД в течение 3х дней'
          }
          confirmText='Расторгнуть'
          onConfirm={confirmTerminateContract}
        />
      )}

      {showTerminateModalWithOrders && (
        <ModalConfirm
          setShowLogoutModal={setShowTerminateModalWithOrders}
          title='Расторжение договора'
          text='По данному договору есть опубликованные заказы. Отмени заказы и затем расторгни договор'
          onConfirm={confirmTerminateContract}
        />
      )}

      {showCommentModal && (
        <ModalComment
          setShowCommentModal={setShowCommentModal}
          onConfirm={confirmAddComment}
          currentComment={contract.comment || ''}
        />
      )}
    </>
  );
};
